import { z } from 'zod';

/** 厂商设备元数据 Zod schema（各交付类型 pricing 字段共用，避免漏字段被 strip） */
export const VendorDeviceMetaSchema = z.object({
  vendor: z.string().optional(),
  vendorID: z.string().optional(),
  device: z.string().optional(),
  deviceID: z.string().optional(),
  deviceType: z.string().optional(),
  billItemId: z.string().optional(),
  quantityUnit: z.string().optional(),
});

/** 可选厂商设备元数据 */
export const OptionalVendorDeviceMetaSchema = VendorDeviceMetaSchema.optional();

/** 计价覆盖字段：在 meta 上可额外带 requirement */
export const PricingMetaSchema = VendorDeviceMetaSchema.extend({
  requirement: z.string().optional(),
}).optional();
